export default "__VITE_ASSET__CEMbAtf5__"